import React from "react"
import PageBanner from "../Components/PageBanner";


const Admissionp = () => {
    return (
        <div className="pt-20 bg-[#F6F5F1]">
            <PageBanner eyebrow="Admissions" title="Admission" />

            <div className="flex flex-col items-center text-center px-4 py-24">
                {/* <Admissionbutton /> */}
                <p
                    className="text-[#12213D] text-2xl mb-2"
                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                >
                    Coming soon
                </p>
                <p
                    className="text-[#5B6472] max-w-md"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                >
                    Admissions details for this page are being finalized. Check back shortly, or reach out via our contact page for questions in the meantime.
                </p>
            </div>
        </div>
    )
}

export default Admissionp;